export { default as scIcon } from './display/scIcon';
